import KunLoading12 from './src/index'

KunLoading12.install = function (Vue) {
	Vue.component(KunLoading12.name, KunLoading12);
}

export default KunLoading12;
